export const config = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/$/, ""),
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "",
  leagueId: import.meta.env.VITE_LEAGUE_ID ?? "wnba",
};

export function requireConfig<K extends keyof typeof config>(key: K): string {
  const value = config[key];
  if (!value) {
    throw new Error(
      `Missing required config: ${String(key)}. Set VITE_${String(key)
        .replace(/[A-Z]/g, (c) => `_${c}`)
        .toUpperCase()} in your .env.`,
    );
  }
  return value;
}
